import { createPortal } from 'react-dom';
import {useEffect} from "react";
import styles from './Toast.module.css';

const Toast = ({ message, onClose, duration = 3000 }) => {
    useEffect(() => {
        const t = setTimeout(onClose, duration);
        return () => clearTimeout(t);
    }, [onClose, duration]);

    return createPortal(
        <div className={styles.toastRoot} role="status" aria-live="polite">
            <div className={styles.toastBody}>
                <span className={styles.toastDot} aria-hidden>•</span>
                <span>{message}</span>
                <button className={styles.toastClose} onClick={onClose} aria-label="Close">×</button>
            </div>
        </div>,
        document.body
    );
}

export default Toast;